import { DELETE, GET, POST } from '../utils/Executer';
import API from './API';
import { COMMUNICATION_SERVICE_URL as servicePath } from '../constants/APIconstants';
import { NEWS_FEED_DASHBOARD_PARAMS } from '../constants/communication.constants';

class CommunicationServiceAPI {
  async sendNotification({ data }) {
    return await API.client.execute(POST, servicePath, data);
  }
  async getNewsFeedItems() {
    return await API.client.execute(
      GET,
      `${servicePath}?filter=${NEWS_FEED_DASHBOARD_PARAMS.filter}&pageSize=${NEWS_FEED_DASHBOARD_PARAMS.pageSize}`,
    );
  }

  /**
   * Delete communication item
   * @param {*} { id }
   * @return {*}
   * @memberof CommunicationServiceAPI
   */
  async deleteItem({ id }) {
    return await API.client.execute(DELETE, `${servicePath}${id}`);
  }
}

export default new CommunicationServiceAPI();
